import {
  createI18n
} from 'vue-i18n'
import en from './en.json'
import ar from './ar.json'
import id from './id.json'
import tr from './tr.json'
import langProp from '@/common/common'

const messages = {
  en: en,
  ar: ar,
  id: id,
  tr: tr
}

const i18n = createI18n({
  locale: langProp.lang,
  fallbackLocale: 'en',
  legacy: false,
  messages
})

export default i18n
